import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';

export const WL_COLORS = {
  gray:   '#9E9E9E', // ไม่มีข้อมูล
  green:  '#00AA00', // ปกติ
  yellow: '#FFFF00', // เฝ้าระวัง
  orange: '#FF8000', // เตือนภัย
  red:    '#FF0000', // วิกฤต (เกินตลิ่ง)
};

const LEGEND_ITEMS = [
  { color: WL_COLORS.red,    label: 'วิกฤต (เกินตลิ่ง)' },
  { color: WL_COLORS.orange, label: 'เตือนภัย' },
  { color: WL_COLORS.yellow, label: 'เฝ้าระวัง' },
  { color: WL_COLORS.green,  label: 'ปกติ' },
  { color: WL_COLORS.gray,   label: 'ไม่มีข้อมูล' },
];

const useStyles = makeStyles({
  legendContainer: {
    zIndex: 99999,
    marginTop: 10,
  },
  legend: {
    height: '20px',
    width: '20px',
    marginRight: 10,
    borderRadius: '50%',
    border: '2px solid #fff',
    boxSizing: 'border-box',
    boxShadow: '0 0 2px rgba(0,0,0,0.4)',
  },
  row: {
    alignItems: 'center',
    flexWrap: 'nowrap',
  },
    label: {
    fontFamily: "'Kanit', sans-serif",
    fontWeight: 400,
  },
});

export default function WaterlevelStatus() {
  const classes = useStyles();

  return (
    <div className={classes.legendContainer}>
      <Paper style={{ opacity: '0.8', backgroundColor: '#EAEAEA' }}>
        <Box p={1}>
          {LEGEND_ITEMS.map((item) => (
            <Grid container key={item.label} className={classes.row}>
              <Grid item>
                <div
                  style={{ backgroundColor: item.color }}
                  className={classes.legend}
                />
              </Grid>
              <Grid item>
                <Typography variant="subtitle2" className={classes.label}>
                  {item.label}
                </Typography>
              </Grid>
            </Grid>
          ))}
        </Box>
      </Paper>
    </div>
  );
}